import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import logoEcs from '@assets/images/logo/ecs-logo.png';
import logoEcsOccitanie from '@assets/images/logo/ecs-occitanie-logo.png';
import { setCompanyChoice, getCompanyChoice, setCompanyApiUrl, setCompanyAppName, Company } from '@features/company/company.slice';

export const useCompanyChoicePageVM = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const companySelected = useSelector(getCompanyChoice);
    const companies: Company[] = [
        {
            id: 'ecs',
            name: 'ECS',
            logo: logoEcs,
            apiUrl: 'https://preprod-ecs-api.getup.agency/',
            appName: 'ecs.energie-cote-sud.com'
        },
        {
            id: 'ecs-occitanie',
            name: 'ECSO',
            logo: logoEcsOccitanie,
            apiUrl: 'https://preprod-ecs-occitanie-api.getup.agency/',
            appName: 'ecs-occitanie.energie-cote-sud.com'
        }
    ];
    const [selectedCompany, setSelectedCompany] = useState<Company | null>(
        companies.find((company) => company.id === companySelected) || null
    );

    const handleCompanySelect = (company: Company) => {
        setSelectedCompany(company);
    };

    const handleContinue = () => {
        if (selectedCompany) {
            dispatch(setCompanyChoice(selectedCompany.id));
            dispatch(setCompanyApiUrl(selectedCompany.apiUrl));
            dispatch(setCompanyAppName(selectedCompany.appName));
            navigate('/login');
        }
    };

    return {
        companies,
        selectedCompany,
        handleCompanySelect,
        handleContinue,
        companySelected
    };
};
